import React, { useContext, useEffect, useState } from 'react';
import './SceneDialogContent.scss';
import { DguidewalksContext } from '../../../JSDC/Dguidewalks/Context';
import { Article } from '../../../JSDC/Dguidewalks/proxyParser/@types';
import { getCityAndTown } from '../../../service-worker';
import { getListingCategoryStyle } from '../../../JSDC/utils/listingCategoryIcon';
import Target from '../../Icons/Target';
// import NavigatorArrow from '../../Icons/NavigatorArrow';

type SceneArticle = Article & { region?: string };

export interface ISceneDialogContentProps {
  onTarget: (article: Article) => void;
  onNavigate: (title: string, latitude?: number, longitude?: number) => void;
  cardsReducer?: (data: Article[]) => Article[];
}

const SceneDialogContent: React.FC<ISceneDialogContentProps> = ({
  onTarget,
  onNavigate,
  cardsReducer = (data: Article[]) => data,
}: ISceneDialogContentProps) => {
  const { dgw } = useContext(DguidewalksContext);
  const [_articles, setArticles] = useState<SceneArticle[]>([]);

  const articles = cardsReducer(_articles) as SceneArticle[];

  const fetchArticles = async () => {
    const data = await dgw.getSceneArticles();
    const enriched: SceneArticle[] = await Promise.all(
      data.map(async (article) => {
        if (typeof article.longitude === 'number' && typeof article.latitude === 'number') {
          const { city, town } = await getCityAndTown(article.longitude, article.latitude);
          return { ...article, region: `${city} ${town}`.trim() };
        }
        return article;
      }),
    );
    setArticles(enriched);
  };

  // const padNumber = (d: number) => {
  //   return d < 10 ? '0' + d.toString() : d.toString();
  // };

  useEffect(() => {
    fetchArticles();
  }, []);
  return (
    <div className="dui-SceneDialogContent">
      {articles.map((article, index) => (
        <div key={index} className="dui-SceneDialogContent-row">
          <div className="dui-SceneDialogContent-picture">
            <img src={article.imgSrc} />
            {/* <p
              className="geonavigator"
              onClick={() => onNavigate(article.title, article.latitude, article.longitude)}
            >
              <NavigatorArrow />
            </p> */}
          </div>
          <div className="dui-SceneDialogContent-content">
            <div className="content-header">
              <div className="header-title">{article.title}</div>
              <div className="header-action" onClick={() => onTarget(article)}>
                <Target color={'var(--dui-secondary)'} />
              </div>
            </div>
            <div className="dui-SceneDialogContent-meta">
              {article.category ? (
                <div className="meta-item">
                  <i
                    className={`las ${getListingCategoryStyle(article.category).icon}`}
                    style={{ color: getListingCategoryStyle(article.category).color }}
                  />
                  <span>{article.category}</span>
                </div>
              ) : null}
              {article.content ? (
                <div className="meta-item">
                  <i className="las la-water" />
                  <span>{article.content}</span>
                </div>
              ) : null}

              {article.region ? (
                <div className="meta-item">
                  <i className="las la-map-marker-alt" />
                  <span>{article.region}</span>
                </div>
              ) : null}
              {article.reporter ? (
                <div className="meta-item">
                  <i className="las la-user" />
                  <span>{article.reporter}</span>
                </div>
              ) : null}
              {article.reportDate ? (
                <div className="meta-item">
                  <i className="las la-calendar" />
                  <span>{article.reportDate}</span>
                </div>
              ) : null}
            </div>
            <div className="dui-SceneDialogContent-footer">
              {/* <div className="count">{`${padNumber(index + 1)}/${articles.length}`}</div> */}
              {article.link ? (
                <a className="more" target="_blank" href={article.link}>
                  more
                </a>
              ) : null}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
SceneDialogContent.displayName = 'SceneDialogContent';
export default SceneDialogContent;
